import { format, parse, isValid } from 'date-fns'
import { useTheme } from '@mui/material/styles'
import useSmartTranslation, { useLocalizationProviderAdapterLocale } from '../useSmartTranslation/useSmartTranslation'
import { localeCodeOf } from '../../utilities/customLanguage'

function useDateFormatter () {
  const { i18n } = useSmartTranslation()
  const { dateFormats } = useTheme()
  const fmt = dateFormats[localeCodeOf(i18n.language)] || dateFormats.en
  const localeObj = useLocalizationProviderAdapterLocale()

  const safeDateParse = (date) => {
    if (!date) return null
    if (date instanceof Date) {
      return isValid(date) ? date : null
    }
    const parsed = new Date(date)
    return isValid(parsed) ? parsed : null
  }

  return {
    format: fmt,
    ampm: false,
    formatTime: (date) => {
      const safeDate = safeDateParse(date)
      return safeDate ? format(safeDate, fmt.time, { locale: localeObj }) : ''
    },
    formatDate: (date) => {
      const safeDate = safeDateParse(date)
      return safeDate ? format(safeDate, fmt.date, { locale: localeObj }) : ''
    },
    formatDateTime: (date) => {
      const safeDate = safeDateParse(date)
      return safeDate ? format(safeDate, fmt.dateTime, { locale: localeObj }) : ''
    },
    parseDateTime: (strDate) => {
      if (!strDate) return null
      if (isValid(strDate)) {
        return strDate
      }
      const parsed = parse(strDate, fmt.dateTime, new Date())
      return isValid(parsed) ? parsed : null
    },
    parseDate: (strDate) => {
      if (!strDate) return null
      const parsed = parse(strDate, fmt.date, new Date())
      return isValid(parsed) ? parsed : null
    }
  }
}

export default useDateFormatter
